/*global google */

define('views/modals/organization/content',['require','jquery','underscore','lib/utils','views/base/view','text!templates/modals/organization/content.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        utils = require('lib/utils'),
        View = require('views/base/view'),
        template = require('text!templates/modals/organization/content.ejs');

    var OrganizationModalContentView = View.extend({
        autoRender: true,
        className: 'organization-modal-content',
        region: 'modal-content',
        template: template,
        events: {
            'click .map-show': 'onClickMapShow',
            'click .map-hide': 'onClickMapHide',
            'click .table-show': 'onClickTableShow',
            'click .table-hide': 'onClickTableHide',
            'click .details-show': 'onClickDetailsShow',
            'click .details-hide': 'onClickDetailsHide'
        },
        listen: {
            'afterLoad model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            this.model.load();
        },
        render: function() {
            View.prototype.render.apply(this, arguments);

            var geolink = this.model.get('geolink');
            if(geolink && geolink.length > 0){
                var rReolink = geolink.match(/[^[\]]+(?=])/g);
                if(rReolink && rReolink.length){
                    var gParts = rReolink[0].split('|');
                    if(gParts.length === 3){
                        this.model.set('gParts', gParts);
                        this.model.set('mapShow', false);
                    }
               }
            }
        },
        onClickMapShow: function(){
            var self = this;
            this.showContent('map');
            setTimeout(function(){
                var mapShow = self.model.get('mapShow');
                if(!mapShow){
                    var gParts =self.model.get('gParts');
                    var zoom = parseInt(gParts[2], 10);
                    var orgLatLng = {lat: parseFloat(gParts[1]), lng: parseFloat(gParts[0])};

                    var map = new google.maps.Map(self.$('.map-container>div')[0], {
                        zoom: zoom,
                        center: orgLatLng,
                        mapTypeId: google.maps.MapTypeId.ROADMAP
                    });

                    var marker = new google.maps.Marker({
                        map: map,
                        position: orgLatLng
                    });

                    self.map = map;
                    self.marker = marker;

                    self.model.set('mapShow', true);
                }
            }, 300);
        },
        onClickMapHide: function(){
            this.hideContent('map');
        },
        onClickTableShow: function(){
            this.showContent('table');
        },
        onClickTableHide: function(){
            this.hideContent('table');
        },
        onClickDetailsShow: function(){
            this.showContent('details');
        },
        onClickDetailsHide: function(){
            this.hideContent('details');
        },
        showContent: function(name){
            this.$('.' + name + '-container').addClass('expanded');
            this.$('.' + name + '-show').addClass('hidden');
            this.$('.' + name + '-hide').removeClass('hidden');
        },
        hideContent: function(name){
            this.$('.' + name + '-container').removeClass('expanded');
            this.$('.' + name + '-hide').addClass('hidden');
            this.$('.' + name + '-show').removeClass('hidden');
        }

    });

    return OrganizationModalContentView;
});

